import React from "react";
import { StyledFooterButtons, StyledModalFooter } from "../styled/Footer";
/**
 * ModalFooter is a component intended to be composed inside a Modal.
 *
 * It is a simple default implementation of a footer, only rendering the given
 * children (ideally buttons) flush-right
 */
export var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledModalFooter, {
    className: className
  }, /*#__PURE__*/React.createElement(StyledFooterButtons, null, children));
};
//# sourceMappingURL=ModalFooter.js.map